document.addEventListener("DOMContentLoaded", () => {
  let defaultBackground = "#F7F7F5";
  const mainElement = document.querySelector('main');

  // Set default initial background color
  mainElement.style.backgroundColor = defaultBackground;

  const frontPage = document.querySelector('.front-page');
  if (!frontPage) return;

  // Get all elements with a background color inside front-page
  const getColorSections = () => {
    const allElements = frontPage.querySelectorAll('*');
    const colorElements = [];

    allElements.forEach(element => {
      const bgColor = getComputedStyle(element).backgroundColor;
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)') {
        colorElements.push({ element, color: bgColor });
      }
    });

    return colorElements;
  };

  const colorSections = getColorSections();

  colorSections.forEach(section => {
    section.element.dataset.bgColor = section.color;
  });

  let lastColor = defaultBackground;

  // Observer to detect when an element is in the viewport
  const observer = new IntersectionObserver((entries) => {
    let visibleSections = entries.filter(entry => entry.isIntersecting);

    if (visibleSections.length > 0) {
      let lastVisible = visibleSections[visibleSections.length - 1].target;
      let bgColor = lastVisible.dataset.bgColor;

      if (bgColor !== lastColor) {
        mainElement.style.backgroundColor = bgColor;
        lastColor = bgColor;
      }

      colorSections.forEach(section => {
        section.element.style.backgroundColor = bgColor;
      });

    } else {
      mainElement.style.backgroundColor = defaultBackground;
      lastColor = defaultBackground;
      colorSections.forEach(section => {
        section.element.style.backgroundColor = '';
      });
    }
  }, {
    threshold: 1
  });

  colorSections.forEach(section => observer.observe(section.element));
});
